import { api } from '../api'

// todo interface

interface GuideItem {
  id: number
  collection_name: string
  file_name: string
  title: string
  type: string
  size: string
  mime_type: string
  url: string
  thumbnail: string
  date_created: string
  ext: string
}

type IGuideResponse = {
  data: GuideItem[]
}

export const guidesAPI = api.injectEndpoints({
  endpoints: (builder) => ({
    getGuides: builder.query<
      IGuideResponse,
      { developerId: number; payload?: any }
    >({
      query: ({ developerId, payload }) => {
        return {
          url: `/companies/${developerId}/guides`,
          params: payload,
        }
      },
      providesTags: <any>['Guide'],
    }),
    getSingleGuide: builder.query<
      IGuideResponse,
      { developerId: number; media: number }
    >({
      query: ({ developerId, media }) => {
        return {
          url: `/companies/${developerId}/guides/${media}`,
        }
      },
    }),
  }),
})

export const { useGetGuidesQuery, useGetSingleGuideQuery } = guidesAPI
